var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconOutlineCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.35 4.5c1.737 0 3.15 1.442 3.15 3.214v8.572c0 1.772-1.413 3.214-3.15 3.214H4.65c-1.737 0-3.15-1.442-3.15-3.214V7.714C1.5 5.942 2.913 4.5 4.65 4.5zm1.05 6.429H3.6v5.357c0 .59.47 1.071 1.05 1.071h14.7c.58 0 1.05-.48 1.05-1.071v-5.357zm-9.45 2.142c.578 0 1.05.483 1.05 1.072 0 .59-.473 1.071-1.05 1.071h-4.2c-.577 0-1.05-.482-1.05-1.071 0-.59.473-1.072 1.05-1.072zm6.3 0c.578 0 1.05.483 1.05 1.072 0 .59-.473 1.071-1.05 1.071h-2.1c-.578 0-1.05-.482-1.05-1.071 0-.59.473-1.072 1.05-1.072z",
    fill: "#F60",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconOutlineCreditCard);
export default __webpack_public_path__ + "static/media/atoms-icon-outline-credit-card.b5e5d295f5816d598fe6afd1281f81b1.svg";
export { ForwardRef as ReactComponent };